import UnauthorizedPage from "./UnauthorizedPage";

export default UnauthorizedPage;